export enum ApprovalType {
    Preauth = '0',
    Claim = '1',
    Prescription = '2'
}

/** Coerce API/form values (0, 1, 2 or '0', '1', '2' or 'Claim', 'Prescription', 'Preauth') to {@link ApprovalType}. */
export function normalizeApprovalType(value: ApprovalType | string | number | null | undefined): ApprovalType {
    if (value == ApprovalType.Claim || ApprovalTypeLabel[ApprovalType.Claim].toLocaleLowerCase() === value.toString().toLocaleLowerCase())
        return ApprovalType.Claim;
    else if (value == ApprovalType.Prescription || ApprovalTypeLabel[ApprovalType.Prescription].toLocaleLowerCase() === value.toString().toLocaleLowerCase())
        return ApprovalType.Prescription;
    else
        return ApprovalType.Preauth;
}

export const ApprovalTypeLabel: { [key in ApprovalType]: string } = {
    [ApprovalType.Preauth]: 'Preauth',
    [ApprovalType.Claim]: 'Claim',
    [ApprovalType.Prescription]: 'Prescription'
};

export const ApprovalTypeTranslatedLabel: { [key in ApprovalType]: string } = {
    [ApprovalType.Preauth]: 'PREAUTH.TITLE',
    [ApprovalType.Claim]: 'CLAIM.CLAIM',
    [ApprovalType.Prescription]: 'PRESCRIPTION.TITLE'
};

